import orderBy from "lodash/orderBy";
import isEqual from "lodash/isEqual";
import moment from "moment";
import isEmpty from "assets/scripts/utils/isEmpty";
import getAccountDisclaimer from "assets/scripts/utils/getAccountDisclaimer";
export default function groupAccounts(accounts, locale) {
    const deceased = {
        values: [],
        routeMap: {}
    };
    const live = {
        values: [],
        routeMap: {}
    };
    for (const account of accounts) {
        if (account.deceased) {
            addToGroup(account, deceased, locale);
        }
        else {
            addToGroup(account, live, locale);
        }
    }
    return {
        deceased: getCompletedValues(deceased),
        live: getCompletedValues(live)
    };
}
export function groupAccountsAll(accounts, locale) {
    const { deceased, live } = groupAccounts(accounts, locale);
    return [
        ...deceased,
        ...live
    ];
}
function addToGroup(account, group, locale) {
    const key = account.seed == null ? `${account.clientGroup}-I${account.id}` : `${account.clientGroup}-S${account.seed}`;
    let routeGroup = group.routeMap[key];
    if (routeGroup == null) {
        routeGroup = {
            primary: null,
            accounts: [],
            open: false,
            balance: 0,
            callbackAccount: null,
            callbackStartTime: null,
            probateCaseAccount: null,
            decLastName: null,
            decLastNameMatches: true,
            disclaimer: null,
            disclaimerMatches: true,
            paymentAllowedAt: null
        };
        group.routeMap[key] = routeGroup;
        group.values.push(routeGroup);
    }
    routeGroup.accounts.push(account);
    if (account.refNum === account.seed) {
        routeGroup.primary = account;
    }
    if (!account.accountClosed) {
        routeGroup.open = true;
        routeGroup.balance += account.balance;
        if (account.paymentAllowedAt != null) {
            const paymentAllowedAt = moment(account.paymentAllowedAt);
            if (routeGroup.paymentAllowedAt == null || routeGroup.paymentAllowedAt.isBefore(paymentAllowedAt)) {
                routeGroup.paymentAllowedAt = paymentAllowedAt;
            }
        }
    }
    if (account.callback != null) {
        const callbackStartTime = moment(account.callback.startTimeUtc);
        if (routeGroup.callbackStartTime == null || routeGroup.callbackStartTime.isAfter(callbackStartTime)) {
            routeGroup.callbackAccount = account;
            routeGroup.callbackStartTime = callbackStartTime;
        }
    }
    if (routeGroup.probateCaseAccount == null && account.probateCase != null) {
        routeGroup.probateCaseAccount = account;
    }
    if (account.deceased
        && routeGroup.decLastNameMatches
        && !isEmpty(account.lastName)) {
        if (routeGroup.decLastName == null) {
            routeGroup.decLastName = account.lastName;
        }
        else if (routeGroup.decLastName !== account.lastName) {
            routeGroup.decLastNameMatches = false;
        }
    }
    if (routeGroup.disclaimerMatches) {
        const disclaimers = getAccountDisclaimer(account, locale);
        if (!!disclaimers.length) {
            if (routeGroup.disclaimer == null) {
                routeGroup.disclaimer = disclaimers;
            }
            else if (!isEqual(routeGroup.disclaimer, disclaimers)) {
                routeGroup.disclaimerMatches = false;
            }
        }
    }
}
function getCompletedValues(group) {
    return group.values.map(value => {
        const { accounts, open, balance, probateCaseAccount, paymentAllowedAt } = value;
        const primary = value.primary || orderBy(value.accounts, it => it.id)[0];
        return {
            primary,
            accounts,
            open,
            balance,
            callbackAccount: value.callbackAccount || primary,
            probateCaseAccount: primary.probateCase != null || probateCaseAccount == null ? primary : probateCaseAccount,
            decLastName: value.decLastNameMatches ? value.decLastName : null,
            disclaimer: value.disclaimerMatches ? value.disclaimer : null,
            paymentAllowedAt: paymentAllowedAt == null ? null : paymentAllowedAt.toISOString()
        };
    });
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/Dashboard/groupAccounts.ts